"use client";

import { ChartCard } from "@/components/ui/chart-card";
import { DonutChartSkeleton, LegendSkeleton } from "@/components/ui/chart-skeletons";

export default function MarketAnalysisSkeleton() {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
      <ChartCard 
        title="Share of Revenue"
        subtitle="Market share distribution by revenue across competing apps"
      >
        <div className="flex flex-col h-full">
          <DonutChartSkeleton size="md" />
          <div className="mt-4">
            <LegendSkeleton itemCount={5} layout="vertical" showIcon={true} />
          </div>
        </div>
      </ChartCard>
      <ChartCard 
        title="Share of Downloads"
        subtitle="Market share distribution by download volume across competing apps"
      >
        <div className="flex flex-col h-full">
          <DonutChartSkeleton size="md" />
          <div className="mt-4">
            <LegendSkeleton itemCount={5} layout="vertical" showIcon={true} />
          </div>
        </div>
      </ChartCard>
    </div>
  );
}
